/*
 *  I04DIMPUISCONSI18n.js
 *
 *  Created by Sébastien Hecart on 2017-12-10 17:12:31 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */

export default {
  I04DIMPUISCONS_SECTION_0_TITLE:
    'Calculez la puissance de votre chaufferie en fonction de vos consommations et du changement de la production',
  I04DIMPUISCONS_rendementProduction_uuid_mail: "Type de l'ancienne production",
  I04DIMPUISCONS_in_rendementProduction1: 'Rendement ancienne production',
  I04DIMPUISCONS_in_consommation: 'Consommation',
  I04DIMPUISCONS_dju_ville: 'Ville',
  I04DIMPUISCONS_dju_uuid: 'Degrè jour unifié moyen ',
  I04DIMPUISCONS_in_consigneT: 'Consigne ambiance',
  I04DIMPUISCONS_in_temperatureBase: 'Température de base ext',
  I04DIMPUISCONS_in_nbJourChauffe: 'Nombre jours de chauffe',
  I04DIMPUISCONS_in_tempsReduit: "Nombre d'heures réduit",
  I04DIMPUISCONS_in_deltaTemperatureAbaissement: 'Nombre degrés abaissés',
  I04DIMPUISCONS_SECTION_1_TITLE: '',
  I04DIMPUISCONS_res_intermittence: 'Intermitence',
  I04DIMPUISCONS_rendementProduction_uuid2_mail: 'Type de la nouvelle production',
  I04DIMPUISCONS_in_rendementProduction2: 'Coefficient restitution de puissance',
  I04DIMPUISCONS_res_deperdition: 'Déperdition',
  I04DIMPUISCONS_res_besoinChauffage: 'Puissance générateur'
}
